<script setup lang="ts">
   import { useHeaderContext } from '~/composables/useHeaderContext';

   const { headerContext } = useHeaderContext();
</script>

<template>
   <IpaHeader v-if="headerContext === 'ipa'" />
   <PoloDevPlatformHeader v-else />
</template>

<style scoped></style>
